import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { convertUTCDateToLocalDate, fillPlaceholders } from '@skylab-shared/utils';
import { FiscalDeviceRegistryCreateEventData, FiscalDeviceRegistryEventResponse } from './fiscal-device-registry-create-event.command-base';

export type FiscalDeviceRegistryUpdateEventData = FiscalDeviceRegistryCreateEventData & {
    readonly eventId: number;
    readonly data: {
        version: string;
    }
};

export class FiscalDeviceRegistryUpdateEventCommand extends Command<FiscalDeviceRegistryUpdateEventData, FiscalDeviceRegistryEventResponse> { }

export class FiscalDeviceRegistryUpdateEventCommandHandlerBase implements CommandHandler<FiscalDeviceRegistryUpdateEventCommand, FiscalDeviceRegistryUpdateEventData, FiscalDeviceRegistryEventResponse> {
    private static Url = TaggedUrl.join('system/devices/:deviceId/events/:eventId', [Tags.Api]);

    public constructor(
        private readonly http: HttpService
    ) {}

    public async handleAsync(command: FiscalDeviceRegistryUpdateEventCommand): Promise<FiscalDeviceRegistryEventResponse> {
        const { data } = await this.http.put(fillPlaceholders(FiscalDeviceRegistryUpdateEventCommandHandlerBase.Url, { deviceId: command.params?.deviceId, eventId: command.params?.eventId }), {...command.params?.data, date: convertUTCDateToLocalDate()});

        return data;
    }
}
